function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconFallbackUser = function SvgIconFallbackUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9923_93900)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.683594,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D9DCE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71655 50.4133C10.0722 38.2809 34.5539 29.0495 43.2838 50.4133C36.2348 56.649 19.9407 60.2819 8.71655 50.4133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.9998,
    cy: 21.7855,
    r: 10.098,
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9923_93900"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.683594,
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  }))));
};
export default SvgIconFallbackUser;